import { useContext, useEffect, useState } from "react";
import { StyleContext } from '../../providers/StyleContextProvider';
import { ReactComponent as CheckCircle } from "../../assets/svg/check-circle.svg";
import { JobApplication } from "../../models/JobApplication";
import { AuthContext } from "../../providers/AuthContextProvider";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import useErrorPage from "../../hooks/useErrorPage";
import { getCandidateEmailByRecruiter, getApplicationHistory } from "../../services/RecruiterService";
import { formatDateWithSuperscript } from "../../helpers/Common";
import { ReactComponent as CloseCircle } from '../../assets/svg/close-circle.svg';
import { ApplicationPopUpLoader } from "../Loaders/ApplicationPopUpLoader";

interface Props {
    selectedApplicant: JobApplication;
    isCvLess: boolean;
}

export const StatusTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("applicationStatusTabs");
    const styles = tabStyles.statusTab;
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const [applicationHistory, setApplicationHistory] = useState<string>("");
    const [emailContent, setEmailContent] = useState<string>("");
    const [currentEmailId, setCurrentEmailId] = useState<number>();
    const [emailHide, setEmailHide] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();

    useEffect(() => {
        let applicationId;
        if (props.isCvLess) {
            applicationId = props.selectedApplicant.preApplicationId;
        }
        else {
            applicationId = props.selectedApplicant.jobApplicationId;
        }
        fetchApplicationHistory(applicationId!);
    }, []);

    const closeEmailContent = () => {
        setEmailHide(true);
        setEmailContent("");
    }

    const parseApplicationHistory = (historyString: string) => {
        const wrappedString = `<histories>${historyString}</histories>`;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(wrappedString, "text/xml");
        const historyNodes = xmlDoc.getElementsByTagName("history");
        return Array.from(historyNodes).map(history => ({
            note: history.getElementsByTagName("note")[0]?.textContent || "",
            date: history.getElementsByTagName("date")[0]?.textContent || "",
            name: history.getElementsByTagName("name")[0]?.textContent || "",
            emailId: history.getElementsByTagName("note")[0]?.querySelector(".sent-mail-link")?.getAttribute("data-email-id") || null
        }));
    };

    async function fetchApplicationHistory(applicationId: number) {
        setLoading(true);
        await getApplicationHistory(applicationId, props.isCvLess, recruiter!.recruiterId, recruiter!.token)
        .then((response: string) => {
            setApplicationHistory(response);
            setLoading(false);
        })
        .catch((error) => {
            toErrorPage(error);
        });
    }

    async function getCandidateEmail(emailId: number) {
        await getCandidateEmailByRecruiter(emailId, recruiter!.recruiterId, recruiter!.token)
        .then((response) => {
            setEmailContent(response);
        })
        .catch((error) => {
            toErrorPage(error);
        });
    }

    return (
        <>
            <p style={styles.title}>Status</p>
            {loading ? <ApplicationPopUpLoader/> : <div>
                <div style={styles.historyWrapper}>
                    <div style={styles.historyWrapper.title}>{"History"}</div>
                    {applicationHistory && parseApplicationHistory(applicationHistory).map((historyItem, index, array) => {
                        const isLastItem = index === array.length - 1;
                        return (
                            <div style={styles.appliedWrapper}>
                                <div style={styles.statusStep}>
                                    <CheckCircle style={styles.statusIcon} />
                                    {!isLastItem && <div style={styles.verticalLine}></div>}
                                </div>
                                <div style={{...styles.appliedWrapper.applied, ...(!isLastItem && styles.appliedWrapper.applied.borderBottom)}}>
                                    <div style={styles.appliedWrapper.statusWrapper}>
                                        <div style={styles.appliedWrapper.text}>
                                            {historyItem.emailId ? (
                                                <span>
                                                    Email Sent{" "}
                                                    <a
                                                        href="javascript:void(0);"
                                                        style={styles.viewText}
                                                        onClick={() => {
                                                            if (historyItem.emailId) {
                                                                setEmailContent("");
                                                                getCandidateEmail(parseInt(historyItem.emailId));
                                                                setCurrentEmailId(parseInt(historyItem.emailId));
                                                                setEmailHide(false);
                                                            }
                                                        }}
                                                    >
                                                        View
                                                    </a>
                                                </span>
                                            ) : (
                                                <span>{historyItem.note}</span>
                                            )}
                                        </div>
                                        <div style={styles.appliedWrapper.date}>{formatDateWithSuperscript(new Date(historyItem.date))}</div>
                                    </div>
                                    {historyItem.name && <div style={styles.appliedWrapper.name}>{"( "+ historyItem.name +")"}</div>}
                                    {(!emailHide && historyItem.emailId !== null && currentEmailId === parseInt(historyItem.emailId)) && (<div style={styles.appliedWrapper.email}>
                                        <CloseCircle style={styles.appliedWrapper.closeButton} onClick={() => closeEmailContent()}/>
                                        <div
                                            style={styles.appliedWrapper.emailContent}
                                            dangerouslySetInnerHTML={{ __html: emailContent }}
                                        />
                                    </div>)}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>}
        </>
    );
}
